
<template>
  <v-menu :nudge-width="210" offset-y>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on" color="grey" v-if="profile && profile.profile_image">
        <v-avatar  class="profile text-center" size="30">
          <v-img :src="profile.profile_image" alt="profile" />
        </v-avatar>
      </v-list-item>
      <v-list-item v-on="on" color="grey" v-else>
        <v-avatar
          v-if="profile && profile.display_name"
          size="30"
          :color="getProfileColor(profile.display_name[0])"
        >
          <span
            v-if="profile.user"
            class="text-uppercase white--text"
          >{{profile.display_name[0]}}{{profile.display_name[1]}}</span>
        </v-avatar>
      </v-list-item>
    </template>
    <v-card class="profile-menu">
      <v-list>
        <v-list-item class="text-center">
          <v-list-item-content v-if="profile && profile.profile_image">
            <v-avatar  class="profile text-center" size="80">
              <v-img :src="profile.profile_image" :alt="profile.display_name" title="Profile"/>
            </v-avatar>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-avatar
              v-if="profile && profile.display_name"
              size="80"
              :color="getProfileColor(profile.display_name[0])"
            >
              <span
                v-if="profile"
                class="text-uppercase white--text"
              >{{profile.display_name[0]}}{{profile.display_name[1]}}</span>
            </v-avatar>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="text-center"  v-if="profile && profile.display_name">
          <v-list-item-content v-if="profile">
            <small class="text-capitalize">{{getRole()}}</small>
            <v-list-item-title  v-if="profile && profile.display_name">
              <h4>{{profile.display_name}}</h4>
            </v-list-item-title>
            <v-list-item-subtitle v-if="profile">{{profile.international_id}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
         <v-list-item>
           <v-spacer/>
          <div>            
            <v-btn
              rounded
              outlined
              x-small
              class="primary"
              dark        
              :to="'/switch-role'"
            >Change Role</v-btn>
          </div>
           <v-spacer/>
        </v-list-item>
        <v-list-item>
           <v-spacer/>
          <div>            
            <v-btn
              rounded
              outlined
              small
              color="#666"              
              :to="'/profile'"
            >Manage your account</v-btn>
          </div>
           <v-spacer/>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions class="ma-2">
        <v-spacer/>
        <v-btn @click="logout()" class="red"  block outlined dark>Sign out</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { filters } from "../../utility/filters";

export default {
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),      
    };
  },

  computed: {
    ...mapGetters({     
      loading: "loading",
      profile: "profile",
      role:"getRole"
    })
    
  },

  watch:{
    role(){    
      this.getRole();
    }
  },


  methods: {
    logout: function() {
      this.$store.dispatch("auth/destroyToken").then(response => {
        if (response) {
          this.$router.push("/login");
        }
      });
    },
    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },

    getRole(){     
      return this.role;
    }
  }
};
</script>


